<template>
  <div class="flex-grid-1-col gutter-md">
    <div class="input card-holder">
      <input type="text" id="card-holder" name="CardHolderName" value="Jhon Doe" class="req" data-val-required="Card holder name is required.">
      <label for="card-holder" class="floating req is-active">{{ tc('formFields.cardHolder') }}</label>
    </div>
    <div class="input card-number">
      <div id="card-number">
        <input type="text" id="card-number" name="CardNumber" class="req" value="4111111111111111" maxlength="16" data-val-required="Card number is required.">
      </div>
      <label for="card-number" class="floating req is-active">{{ tc('formFields.cardNumber') }}</label>
    </div>
    <div class="input card-exp">
      <div id="card-exp">
        <input type="text" id="card-exp" name="CardExpirateDate" class="req" value="12/26" data-val-required="Exp data is required." maxlength="5" pattern="\d{4}">
      </div>
      <label for="card-exp" class="floating req is-active">{{ tc('formFields.cardExpirationDate') }}</label>
    </div>
    <div class="input card-code">
      <div id="card-code">
        <input type="text" id="card-code" name="cardCode" class="req" value="VI" data-val-required="Exp data is required." pattern="\d{4}">
      </div>
      <label for="card-exp" class="floating req is-active">Card Code</label>
    </div>
    <p>This credit card form is intended for the local environment only. VGS form for the local environment is disabled.</p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditCardForm',
    computed: {
      ...mapGetters('i18n', ['tc'])
    }
  }
</script>
